module.exports = "#define SHADER_NAME PHASER_FLAT_TINT_FS\r\n\r\nprecision mediump float;\r\n\r\nvarying vec4 outTint;\r\n\r\nvoid main() {\r\n    gl_FragColor = vec4(outTint.rgb * outTint.a, outTint.a);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./renderer/webgl/shaders/FlatTint.frag
// module id = 538
// module chunks = 0